function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m145.96875 423.246094h-36.707031l84.6875-84.375-21.171875-21.253906-84.476563 84.164062v-36.203125h-30v87.667969h87.667969zm0 0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m366.03125 423.246094v30h87.667969v-87.667969h-30v36.203125l-84.476563-84.164062-21.171875 21.253906 84.6875 84.375zm0 0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m88.300781 110.21875 84.476563 84.164062 21.171875-21.253906-84.6875-84.375h36.707031v-30h-87.667969v87.667969h30zm0 0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m339.222656 194.382812 84.476563-84.164062v36.203125h30v-87.667969h-87.667969v30h36.707031l-84.6875 84.375zm0 0"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m0 0v512h512v-512zm482 482h-452v-452h452zm0 0"
});

var SvgMaximize = function SvgMaximize(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512 512",
    width: "512pt",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMaximize, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/maximize.9c0571ce.svg";
export { ForwardRef as ReactComponent };